import { render } from "./OptionsManager.vue?vue&type=template&id=4d42b94b&scoped=true"
import script from "./OptionsManager.vue?vue&type=script&lang=js"
export * from "./OptionsManager.vue?vue&type=script&lang=js"

import "./OptionsManager.vue?vue&type=style&index=0&id=4d42b94b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d42b94b"]])

export default __exports__